import { render, staticRenderFns } from "./CekOngkir.vue?vue&type=template&id=9b5dea02"
import script from "./CekOngkir.vue?vue&type=script&lang=js"
export * from "./CekOngkir.vue?vue&type=script&lang=js"
import style0 from "./CekOngkir.vue?vue&type=style&index=0&id=9b5dea02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports